export default __webpack_public_path__ + "static/media/0721_DSC8313.6cf158f6.jpg";